import { useContent } from '@/content'
import { cn } from '@/lib/cn'
import { Marquee } from '@/components/ui'
import styles from './ExpertiseMarquee.module.css'

/**
 * The scrolling discipline list in the hero's statement panel. Items
 * alternate between white and accent, separated by outlined rings.
 */
export const ExpertiseMarquee = () => {
  const { expertise } = useContent()

  return (
  <Marquee>
    {expertise.map((item, index) => (
      <span key={item} className={styles.item}>
        <span
          className={cn('t-22', styles.label, index % 2 === 1 && styles.labelAccent)}
        >
          {item}
        </span>
        <span className={styles.ring} aria-hidden="true" />
      </span>
    ))}
  </Marquee>
  )
}
